import { IResolvedSteppers } from '@/src/utils/collections/steppers.mapper';
import { StepperStandardItem } from '@/src/components/steppers/StepperStandard/StepperStandardItem';

export const StepperStandard = ({
  title,
  subtitle,
  items,
  showStepperLine,
}: IResolvedSteppers) => {
  return (
    <div className={`mx-auto my-18 flex max-w-1200 flex-col px-4`}>
      <div className={'mb-4 text-4xl font-semibold md:text-center'}>
        {title}
      </div>
      <div className={'mb-4 text-lg text-gray md:text-center'}>{subtitle}</div>
      <div className={'flex flex-col md:flex-row'}>
        {items.map((item, index) => (
          <StepperStandardItem
            key={item.title + '_' + index}
            {...item}
            last={index === items.length - 1}
            showStepperLine={showStepperLine}
          />
        ))}
      </div>
    </div>
  );
};
